import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var CopyIcon = function CopyIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "CopyIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: [jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.6 6.5H7.4a12 12 0 0 0-.883.017l-.002.02c-.014.175-.015.418-.015.863v5.2a12 12 0 0 0 .017.883l.02.002c.175.014.418.015.863.015h5.2a12 12 0 0 0 .883-.017l.002-.02c.014-.175.015-.418.015-.863V7.4a12 12 0 0 0-.017-.883l-.02-.002A12 12 0 0 0 12.6 6.5m1.581-1.337C13.861 5 13.441 5 12.6 5H7.4c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656C5 6.139 5 6.559 5 7.4v5.2c0 .84 0 1.26.163 1.581a1.5 1.5 0 0 0 .656.656c.32.163.74.163 1.581.163h5.2c.84 0 1.26 0 1.581-.164a1.5 1.5 0 0 0 .656-.655c.163-.32.163-.74.163-1.581V7.4c0-.84 0-1.26-.164-1.581a1.5 1.5 0 0 0-.655-.656",
      clipRule: "evenodd"
    }), jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M9.5 5V3.4a12 12 0 0 0-.017-.883l-.02-.002A12 12 0 0 0 8.6 2.5H3.4a12 12 0 0 0-.883.017l-.002.02c-.014.175-.015.418-.015.863v5.2a12 12 0 0 0 .017.883l.02.002c.175.014.418.015.863.015H5V11H3.4c-.84 0-1.26 0-1.581-.164a1.5 1.5 0 0 1-.656-.655C1 9.861 1 9.441 1 8.6V3.4c0-.84 0-1.26.163-1.581a1.5 1.5 0 0 1 .656-.656C2.139 1 2.559 1 3.4 1h5.2c.84 0 1.26 0 1.581.163a1.5 1.5 0 0 1 .656.656c.163.32.163.74.163 1.581V5z",
      clipRule: "evenodd"
    })]
  }));
};

export { CopyIcon };
